import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getInitialsFromUserName } from '../../utils/common';
import {
  ApMenuItem,
  ApMenuUser,
  ApButtonIcon,
} from '@alixpartners/ui-components';

import { Wrapper } from './MainHeaderRightMenu.styles';

interface IProps {
  userName: string;
  onLogout: () => any;
}

export const MainHeaderRightMenu = ({ userName, onLogout }: IProps) => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <ApButtonIcon
        iconName="outline_settings"
        small
        theme="dark"
        onClick={() => navigate('/settings')}
      />
      <ApMenuUser initials={getInitialsFromUserName(userName)}>
        <ApMenuItem onClick={onLogout}>Logout</ApMenuItem>
      </ApMenuUser>
    </Wrapper>
  );
};
